<template>
  <div class="menu-mgmt">
    <div class="main-title">
      <p>{{ $t('lang.Card Management') }}</p>
    </div>
    <div style="margin-bottom: 40px;"></div>
    <div class="main-body">
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline"
      >
        <el-form-item :label="$t('lang.Card number')">
          <el-input v-model="form.cardNo" :placeholder="$t('lang.Enter or read the card number')" clearable
                    maxlength="50"
                    @input="form.cardNo = form.cardNo.replace(/[^\d]/g,'')"/>
        </el-form-item>
        <el-form-item :label="$t('lang.Agent/Store')">
          <query-unit-tree @change="handleChange"/>
        </el-form-item>
        <el-form-item :label="$t('lang.Battery spec')">
          <el-select v-model="form.batteryStandards" :placeholder="$t('lang.Please select Battery spec')" clearable>
            <el-option
              v-for="item in BATTERY_TYPE"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.Time')">
          <el-date-picker
            :default-time="['00:00:00', '23:59:59']"
            v-model="timeArr"
            type="datetimerange"
            range-separator="-"
            value-format="timestamp"
            :start-placeholder="$t('lang.start time')"
            :end-placeholder="$t('lang.end time')">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('lang.Card status')">
          <el-select v-model="form.voucherStatus" :placeholder="$t('lang. Please select card status')" clearable>
            <el-option
              v-for="item in CARD_STATUS"
              :key="item.value"
              :label="$t(`lang.${item.label}`)"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="queryCardInfoList">{{ $t('lang.Inquire') }}</el-button>
        <el-button type="primary" @click="openCardHandle">{{ $t('lang.Open card') }}</el-button>
        <!-- v-if="openCard" -->
        <el-button type="primary" @click="renewBtn">{{ $t('lang.Renew') }}</el-button>
      </el-form>
      <el-table
        :data="recordList"
        style="width: 100%;margin-bottom: 20px;"
        class="table-custom"
        cell-class-name="text-center"
        row-key="number"
      >
        <!-- :header-row-style="headerStyle" -->
        <!-- :tree-props="{ children: 'subMenuList', hasChildren: 'true' }" -->
        <el-table-column prop="cardNo" :label="$t('lang.Card number')" width="160"></el-table-column>
        <el-table-column prop="unitName" :label="$t('lang.Agent/Store')" width="200"></el-table-column>
        <el-table-column prop="batteryStandards" :label="$t('lang.Battery spec')" width="150px"></el-table-column>
        <el-table-column prop="surplusDays" :label="$t('lang.The remaining number of days')" width="180">
          <template slot-scope="{row}" v-if="row.surplusDays">
            {{ row.surplusDays || 0 }}{{ $t('lang.day') }}
          </template>
        </el-table-column>
        <el-table-column prop="voucherNo" :label="$t('lang.Available times')" width="180">
          <template slot-scope="{row}">
            {{ row.frequency || '--' }}
            <span v-if="row.frequency">{{ $t('lang.times') }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.Current effective time')" width="200">
          <template slot-scope="{row}" v-if="row.startTime || row.endTime">
            {{ $changeTime.showTime(Number(row.startTime), '', 0) }} -
            {{ $changeTime.showTime(Number(row.endTime), '', 0) }}
          </template>
        </el-table-column>
        <el-table-column prop="accountNumber" :label="$t('lang.Account number')" width="200"></el-table-column>
        <el-table-column prop="userName" :label="$t('lang.Username')" width="200"></el-table-column>
        <el-table-column prop="contactInfo" :label="$t('lang.phone')" width="160"></el-table-column>
        <el-table-column prop="createTime" :label="$t('lang.Activation time')" width="200">
          <template slot-scope="{row}">
            {{ $changeTime.showTime(row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('lang.Card status')" width="150">
          <template slot-scope="{row}">
            {{ $t('lang.' + $changeObj(CARD_STATUS)[row.status]) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.Operating')" width="200" fixed="right">
          <template slot-scope="{row}">
            <el-button @click="handleAdd(0,row)" type="primary" size="mini">{{ $t('lang.Edit') }}</el-button>
            <el-button @click="checkDetail(row)" type="primary" size="mini">{{ $t('lang.Details') }}</el-button>
            <div class="mt10">
              <el-button @click="handleAdd(1,row)" type="primary" size="mini">{{ $t('lang.Reset card password') }}</el-button>
            </div>
            <div class="mt10">
              <el-button @click="bindCardBtnClick(row)" type="primary" size="mini">{{ $t('lang.Associated Account') }}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="dfcc">
        <el-pagination
          :current-page="form.beginIndex + 1"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :title="titleObj[type]"
      :visible.sync="dialogTableVisible"
      width="500px"
      :show-close="true"
    >
      <!-- 编辑 -->
      <div v-if="+type === 0">
        <p class="mb20">{{ $t('lang.Card number') }}<span class="ml24">{{ editForm.cardNo }}</span></p>
        <div class="df">
          <p class="labelStyle">{{ $t('lang.phone') }}</p>
          <el-input v-model="editForm.contactInfo" class="mb20" clearable maxlength="11"
                    @keyup.native="editForm.contactInfo = editForm.contactInfo.replace(/[^\d\.\/]/ig,'')"></el-input>
        </div>
        <!-- 改用户名 -->
        <div class="df">
          <p class="labelStyle">{{ $t('lang.name') }}</p>
          <el-input v-model="editForm.userName" class="mb20" clearable maxlength="11"></el-input>
        </div>
        <div class="dfe">
          <el-button @click="dialogTableVisible = false">{{ $t('lang.Cancel') }}</el-button>
          <el-button @click="editBtn" type="primary">{{ $t('lang.Confirm') }}</el-button>
        </div>
      </div>
      <div v-else-if="+type === 1">
        <div class="df mb20">
          <p class="labelStyle longLabel">{{ $t('lang.Please enter the reset card password') }}</p>
          <el-input v-model="passwordForm.passWord" clearable maxlength="12"
                    @keyup.native="passwordForm.passWord = passwordForm.passWord.replace(/[^\w\.\/]/ig,'')"></el-input>
        </div>
        <div class="df mb20">
          <p class="labelStyle longLabel">{{ $t('lang.Please enter the reset card password again') }}</p>
          <el-input v-model="passwordForm.rePassWord" clearable maxlength="12"
                    @keyup.native="passwordForm.rePassWord = passwordForm.rePassWord.replace(/[^\w\.\/]/ig,'')"></el-input>
        </div>
        <div class="dfe">
          <el-button type="primary" @click="chargePassWord">{{ $t('lang.Confirm') }}</el-button>
        </div>
      </div>
      <!-- <div v-else-if="+type === 2">
        <p>重置成功！卡密被重置为{{}}</p>
        <div class="dfe">
          <el-button type="primary" @click="repassword">确定</el-button>
        </div>
      </div> -->
    </el-dialog>
    <el-dialog :title="$t('lang.Associated Account')" :visible.sync="bindVisible" width="30%">
      <div class="bind-input-box">
        <div>{{$t('lang.User ID')}}:</div>
        <el-input
          class="class-input"
          v-model="bindItem.accountNumber"
          :placeholder="$t('lang.Please enter the user ID')"
          clearable
          maxlength="50"
          :disabled="bindItem.bindFlag"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="unbindBtnClick" v-if="bindItem.bindFlag" plain>{{ $t('lang.Unbind') }}</el-button>
        <el-button type="primary" @click="confirmBind">{{$t('lang.Confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {chargePassWord} from '@/api/login';
import {queryCardInfoList, editContactInfo} from '@/api/openCard';
import {BATTERY_TYPE, CARD_STATUS} from '@/utils/constant'
import queryUnitTree from '@/components/common/queryUnitTree';
import {bindBicycleBelongUser, cleanThailandBicycleBelongUser} from '../../api/deviceManagement';
import {cardBindingUser, cardUnbindingUser} from '../../api/openCard';

export default {
  data() {
    return {
      CARD_STATUS,
      BATTERY_TYPE,
      currentPage: 1,
      recordList: [],
      resetPassWard: '',
      timeArr: [],
      // userName:'',//编辑修改用户姓名
      distributionSelect: '',
      editAuthoritySelect: '',
      registerForm: {
        val1: '',
        val2: '',
        val3: ''
      },
      titleObj: {
        0: this.$t('lang.Edit user'),
        1: this.$t('lang.Prompt'),
        2: this.$t('lang.Prompt'),
      },
      type: '',
      total: 0,
      multipleSelection: [],
      unitNo: [],
      editForm: {},
      passwordForm: {
        passWord: '',
        rePassWord: '',
        accountNo: '',
        appType: 11,
        loginType: 5
      },
      form: {
        cardNo: '',
        batteryStandards: '',
        voucherStatus: '',
        beginTime: '',
        endTime: '',
        beginIndex: 0,
        pageSize: 10,
      },
      rules: {
        val1: {required: true, message: this.$t('lang.account cannot be empty'), trigger: 'blur'},
        val2: {required: true, message: this.$t('lang.The password cannot be empty'), trigger: 'blur'},
        val3: {required: true, message: this.$t('lang.The password cannot be empty'), trigger: 'blur'},
      },
      dialogTableVisible: false,
      rowData: {},
      openCard: '',
      renewCard: '',
      //是否显示绑定弹窗的标志
      bindVisible: false,
      //待绑定的卡
      bindItem: {
        bindFlag: false
      },
      isUnbindLoadingFlag: false,
      isBindLoadingFlag: false
    };
  },
  mounted() {
    this.$set(this.timeArr, 0, this.$m().set({
      'hour': 0,
      'minute': 0,
      'seconds': 0
    }).valueOf())
    this.$set(this.timeArr, 1, this.$m().set({
      'hour': 23,
      'minute': 59,
      'seconds': 59
    }).valueOf())
    this.queryCardInfoList();
    this.openCard = this.$route.query.openCard;
    this.renewCard = this.$route.query.renewCard;
    // this.changePassWord = this.$route.query.changePassWord;
  },
  methods: {
    /**
     * 点击绑定按钮
     */
    bindCardBtnClick(item) {
      if(item.accountNumber) {
        item.bindFlag = true
      }
      this.bindItem = JSON.parse(JSON.stringify(item))
      this.bindVisible = true
    },
    /**
     * 进行绑定
     */
    async confirmBind() {
      if(this.isBindLoadingFlag) {
        this.$message.warning(this.$t('lang.In operation') + '...')
        return
      }
      //需要先解绑
      if(this.bindItem.bindFlag) {
        this.$message.warning(this.$t('lang.Please unbind first'))
        return
      }
      const params = {
        cardNo: this.bindItem.cardNo,
        userName: this.bindItem.accountNumber
      }
      try {
        this.isBindLoadingFlag = true
        await cardBindingUser(params)
        this.isBindLoadingFlag = false
        this.bindVisible = false
        this.queryCardInfoList()
        this.$message.success(this.$t('lang.Successful'))
      } catch (e) {
        this.isBindLoadingFlag = false
      }
    },
    /**
     * 解绑按钮点击
     */
    unbindBtnClick() {
      let self = this;
      this.$confirm(this.$t('lang.Are you sure to unbind the account ID') + '?', "", {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.Cancel'),
        type: "warning"
      }).then(() => {
        self.toUnbind();
      }).catch(action => {

      });
    },
    /**
     * 进行解绑
     */
    async toUnbind() {
      if(this.isUnbindLoadingFlag) {
        this.$message.warning(this.$t('lang.In operation') + '...')
        return
      }
      const params = {
        cardNo: this.bindItem.cardNo,
        userName: this.bindItem.accountNumber
      }
      try {
        this.isUnbindLoadingFlag = true
        await cardUnbindingUser(params)
        this.isUnbindLoadingFlag = false
        this.$message.success(this.$t('Successful'))
        this.bindItem.bindFlag = false
        this.bindVisible = false
        this.bindItem.accountNumber = ''
        this.queryCardInfoList()
      } catch (e) {
        this.isUnbindLoadingFlag = false
      }
    },
    // 重置密码
    async chargePassWord() {
      const params = {
        ...this.passwordForm,
      };
      if (this.passwordForm.passWord.length < 6 || !this.passwordForm.passWord) {
        this.$message(this.$t('lang.Password at least 6 characters'));
        return;
      }
      if (this.passwordForm.passWord !== this.passwordForm.rePassWord) {
        this.$message(this.$t('lang.The two passwords do not match'));
        return;
      }
      params.passWord = this.$md5(params.passWord),
        params.rePassWord = this.$md5(params.rePassWord),
        params.accountNo = this.rowData.cardNo;
      try {
        const res = await chargePassWord(params);
        console.log(res, '改密码res');
        if (res.result === 1) {
          this.$message.success(this.$t('lang.Successfully reset!'));
          this.dialogTableVisible = false;
        }
      } catch (e) {
        console.log(e);
      }
    },
    // select组件
    handleChange(val) {
      this.unitNo = val;
    },
    // 查看详情
    checkDetail(row) {
      this.$router.push({
        path: '/managePage/openCard',
        query: row
      });
    },
    //
    renewBtn() {
      this.$router.push('/managePage/alermRecord');
    },
    //   开卡
    openCardHandle() {
      this.$router.push('/managePage/warningRecord');
    },
    //确认修改
    async editBtn() {
      try {
        const params = {
          accountNo: this.editForm.cardNo,
          contactInfo: this.editForm.contactInfo,
          name: this.editForm.userName,
          appType: 11,
          loginType: 5
        };
        const res = await editContactInfo(params);
        console.log(res, '编辑返回');
        if (res.result === 1) {
          this.$message.success(this.$t('lang.Edit success'));
          this.queryCardInfoList();
        }
      } catch (e) {
        console.log(e);
      }
      this.dialogTableVisible = false;

    },
    //pageSize
    handleSizeChange(pageSize) {
      this.form.pageSize = pageSize;
      this.queryCardInfoList();
    },
    // current
    handleCurrentChange(page) {
      this.form.beginIndex = page - 1;
      this.queryCardInfoList();
    },
    // table选择
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    /**获取菜单列表 */
    async queryCardInfoList() {
      const params = {
        ...this.form
      };
      if (this.unitNo && this.unitNo.length > 0) {
        params.unitNo = this.unitNo[this.unitNo.length - 1];
      } else {
        params.unitNo = null;
      }
      if (this.timeArr && this.timeArr.length > 0) {
        params.beginTime = this.$changeTime.sendTime(this.timeArr[0], 'x');
        params.endTime = this.$changeTime.sendTime(this.timeArr[1], 'x');
      } else {
        params.beginTime = null;
        params.endTime = null;
      }
      try {
        console.log(params, 'params');
        const res = await queryCardInfoList(params);
        console.log(res, 'list-res');
        this.recordList = res.ldata;
        this.total = res.mdata.total;
      } catch (e) {
        console.log(e);
      }
    },
    // 新增按钮
    handleAdd(type, row) {
      console.log(row, 'row');
      this.rowData = row;
      this.editForm = {...row};
      // if(type === 0){
      //   // 编辑用户

      // }else if(type === 1){
      //   // 提示
      // }else{
      //   // 提示
      // }
      this.type = type;
      this.dialogTableVisible = true;
    },
    // 注册按钮
    registerBtn(formName) {
      const self = this;
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.registerForm.val2 !== this.registerForm.val3) {
            this.$message.error(this.$t('lang.The two passwords do not match'));
            return;
          }
          try {
            const params = {
              ...this.registerForm
            }
            const res = await send(params);
            console.log(res, 'res');
          } catch (e) {

          }
        } else {
          return false;
        }
      });
    },


    onSubmit() {
      this.createOrUpdate();
    },

    async createOrUpdate() {
      if (this.editRecord.parentMenuNos) {
        this.editRecord.parentMenuNo = this.editRecord.parentMenuNos[
        this.editRecord.parentMenuNos.length - 1
          ];
      }
      console.log(this.editRecord);
      const res = await createOrUpdateMenu(this.editRecord);
      console.log(res);
      this.$message.success(this.$t('lang.Successful'));
      this.closeDialog();
      this.queryCardInfoList(this.params.platformType, "1");
    },
    closeDialog() {
      this.dialogTableVisible = false;
      this.item = {};
    },


    handleDelete(item) {
      this.$confirm(this.$t('lang.Confirm deletion?')).then(() => {
        this.delete(item.number);
      });
    },

    async delete(number) {
      const params = {
        number: number
      };
      const res = await deleteMenu(params);
      console.log(res);
      this.$message.success(this.$t('lang.Successful'));
      this.queryCardInfoList(this.params.platformType, "1");
    },


    showErrorMessage(message) {
      if (message == "0001") {
        this.$message.warning(this.$t('lang.Logon has timed out. Please login again'));
      } else if (message == "0004") {
        console.log(message);
      } else {
        this.$message.error(message);
      }
    }
  },
  components: {
    queryUnitTree,
  }
};
</script>

<style lang="scss" scoped>
.addForm {
  padding: 0 20px 0;
}

.labelStyle {
  height: 32px;
  line-height: 32px;
  width: 160px;
}

.longLabel {
  width: 230px;
  line-height: 16px;
}
.bind-input-box {
  display: flex;
  align-items: center;
  .class-input {
    width: 200px;
    margin-left: 10px;
  }
  .class-button {
    margin-left: 30px;
    color: #4CB132;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/warningMgmt/warningRuleMgmt.vue